<picture>
  @if (largeImageUrl) {
    <source [srcset]="largeImageUrl" media="(min-width: 1024px)" />
  }
  @if (mediumImageUrl) {
    <source [srcset]="mediumImageUrl" media="(min-width: 768px)" />
  }
  @if (smallImageUrl) {
    <source [srcset]="smallImageUrl" media="(min-width: 800px)" />
  }
  <img [src]="smallImageUrl" class="img-rounded" alt=""/>
</picture>
